/**
 * TODO adding for now to be decided later if
 * we will use at app level or file level
 */
import { THEMES } from '@manulife/mux';
import { OTIP_THEME } from '../Components/WrappedMuxProvider/themes/otip';

export const DATE_FORMAT = {
    ISO_STANDARD: 'YYYY-MM-DD',
    MUX_LOCALIZED: 'DD-MM-YYYY',
};

// Application Constants.
export const APP_ROUTES = {
    basePath: '/gb/member-profile-2',
    //Personal
    PersonalTab: '/gb/member-profile-2/personal',
    contactInfoModal: {
        url: '/gb/member-profile-2/personal/editcontact',
        stepUpUrl: '/gb/member-profile-2/public/auth?returnPath=contactInfoModal',
    },
    bankingModal: {
        url: '/gb/member-profile-2/personal/editbank',
        stepUpUrl: '/gb/member-profile-2/public/auth?returnPath=bankingModal',
    },
    emailAddressModal: {
        url: '/gb/member-profile-2/personal/editemail',
        stepUpUrl: '/gb/member-profile-2/public/auth?returnPath=emailAddressModal',
    },
    //Family
    familyTab: '/gb/member-profile-2/family',
    addFamilyModal: '/gb/member-profile-2/family/addfamily',
    editFamilyModal: '/gb/member-profile-2/family/editfamily',
    extendCoverageModal: '/gb/member-profile-2/family/extendcoverage',
    whoIsEligibleModal: '/gb/member-profile-2/family/whoiseligible',
};

export const LOGOUT_TYPE = {
    signout: 'SIGNOUT',
    idle: 'IDLE',
    maxSession: 'MAX_SESSION',
};

// Valid values (allow list) for origin query parameter
export const PLAN_MEMBER_ORIGINS = ['memberPortal', 'planMember', 'gbClaims'];

export const CLAIM_STEP = ['Step1', 'Step3'];

export const ADOBE = {
    PAGE_LOAD: 'page_load',
    TRANSACTION_ERROR: 'transaction_error',
    TRANSACTION_START: 'transaction_start',
    TRANSACTION_STEP: 'transaction_step',
    TRANSACTION_COMPLETE: 'transaction_complete',
};

export const APP_CONSTANTS = {
    MPROFILE_JWT: 'MPROFILE_JWT',
    MPROFILE_SESSION_CORRELATION_ID: 'MPROFILE_SESSION_CORRELATION_ID',
    MPROFILE_ORIGIN: 'MPROFILE_ORIGIN',
    MPROFILE_CLAIMSTEP: 'MPROFILE_CLAIMSTEP',
    MPROFILE_CTX: 'MPROFILE_CTX',
};

export const LOCALE = {
    FR: 'fr-CA',
    EN: 'en-CA',
    FR_NO_REGION: 'fr',
    EN_NO_REGION: 'en',
};

export const BRAND_THEME = {
    OTIP: OTIP_THEME,
    DEFAULT: THEMES.canadianTheme,
};

export const OTIP_ENTITY = ['otipdev', 'otipsit', 'otipuat', 'otip'];

export const APP_URL = {
    GB_BFF_HOST: window.__ENV__.BFF_URL,
    MEMBER_PORTAL_HOST: window.__ENV__.MEMBER_PORTAL_HOST,
    AEM_IMG_PATH: '/aem/v2/image/',
    MEMBER_PORTAL_LOGOUT_PATH: '/public/handlelogout',
    MEMBER_PORTAL_TRANSFER_IN_PATH: '/public/transferin',
};

export const BRAND = {
    OTIP: 'gb-otip',
};
